module.exports = __webpack_public_path__ + "img/stena34.7ae4fc5b.jpg";